import "babel-polyfill";

import React from 'react';
import ReactDOM from 'react-dom';

import {Provider} from 'react-redux';
import {Router, Route, browserHistory, IndexRoute} from 'react-router'
import store from './store/store';


import App from './App';
import AdminUsers from './components/admin/AdminUsers';
import AdminPractices from './components/admin/AdminPractices';
import AdminPractice from './components/admin/AdminPractice';

import AdminTherapyAreas from './components/admin/AdminTherapyAreas';
import AdminTherapyCategories from './components/admin/AdminTherapyCategories';
import AdminPracticeTypes from './components/admin/AdminPracticeTypes'
import AdminVideos from './components/admin/AdminVideos';
import UserProfile from './components/user/UserProfile';
import Practice from './components/practice/Practice';
import PracticeYay from './components/practice/PracticeYay';

import PracticeAdmin from './components/practice_admin/PracticeAdmin';
import OwnerDashboard from './components/owner/OwnerDashboard';

import PatientViewDashboard from './components/practice_admin/patient/PatientViewDashboard';

import PracticeAdminUsers from './components/practice_admin/PracticeAdminUsers';
import PracticeAdminPatients from './components/practice_admin/PracticeAdminPatients';
import PracticeAdminPatient from './components/practice_admin/PracticeAdminPatient';
import TherapistDashboard from './components/therapist/TherapistDashboard';
import ParentDashboard from './components/parent/ParentDashboard';
import TherapistPractice from './components/therapist/TherapistPractice';
import ParentPatientRecord from './components/parent/ParentPatientRecord';
import TherapistPatient from './components/therapist/TherapistPatient';
import AdminUserProfile from './components/admin/AdminUserProfile';
import Signin from './components/signin/Signin';
import Home from './components/home/Home';
import TermsConditions from './components/terms_conditions/terms_conditions';
import VideosPage from './components/home/VideosPage';
import VideoPage from './components/home/VideoPage';
import AreasPage from './components/home/AreasPage';
import AreaPage from './components/home/AreaPage';
import RegisterPage from './components/home/RegisterPage';
import RegisterSuccess from './components/practice_admin/RegisterSuccess';


import Onboarding from './components/onboarding/Onboarding';
import OwnerOnboarding from './components/onboarding/OwnerOnboarding';
import ParentOnboarding from './components/onboarding/ParentOnboarding';
import TherapistOnboarding from './components/onboarding/TherapistOnboarding';


import 'material-typography/css/typography.min.css';
import './styles/index-shell.scss';

store.dispatch({
	type: 'SET_AUTHED',
	payload: false
});
store.dispatch({
	type: 'RESET_MODAL'
})


ReactDOM.render(
	<Provider store={store}>
	<Router onUpdate={() => document.querySelector('.app-content').scrollTo(0,0)} history={browserHistory}>

		<Route path="/page" component={App}>
			<IndexRoute component={Home}></IndexRoute>
			<Route path="/page/register_practice"  component={RegisterPage}></Route>

			<Route path="/page/videos"  component={VideosPage}></Route>
			<Route path="/page/videos/:id" component={VideoPage}></Route>
			<Route path="/page/therapy_areas"  component={AreasPage}></Route>
			<Route path="/page/therapy_areas/:id"  component={AreaPage}></Route>
			<Route path="/page/therapy_categories/:catId"  component={AreasPage}></Route>

		</Route>
		<Route path="/terms_conditions" termsConditions={true} component={App}>
			<IndexRoute component={TermsConditions}></IndexRoute>
		</Route>
		<Route path="/Home"   component={App}>
			<IndexRoute component={Home}></IndexRoute>
		</Route>
		<Route path="/" publicRoute={true}  component={App}>
			<IndexRoute  publicRoute={true} component={Signin}></IndexRoute>
		</Route>
		<Route path="/profile" publicRoute={true}  component={App}>
			<Route path="/profile/:id" publicRoute={true} component={UserProfile}></Route>
		</Route>
		<Route path="/practice" publicRoute={true}  component={App}>
			<Route path="/practice/:name(/:info)" publicRoute={true} component={Practice}></Route>
			<Route path="/yay/practice/:name" publicRoute={true} component={PracticeYay}></Route>
		</Route>

		<Route path="/therapists" therapistRoute={true} component={App}>
			<IndexRoute component={TherapistDashboard}></IndexRoute>
			<Route path="/therapists/practice/:practiceId(/:name)" component={TherapistPractice}></Route>
			<Route path="/therapists/practice/:practiceId/patient/:patientId(/:therapistId)" component={TherapistPatient}></Route>
		</Route>

		<Route path="/parents" therapistRoute={true} component={App}>
			<IndexRoute component={ParentDashboard}></IndexRoute>
			<Route path="/parents/:parentId/patient_record/:patientRecordId" component={ParentPatientRecord}></Route>
		</Route>

		<Route path="/practice_admin" ownerRoute={true} component={App}>
			<IndexRoute  component={OwnerDashboard}></IndexRoute>
			<Route path="/practice_admin/:name"  component={PracticeAdmin}></Route>
			<Route path="/practice_admin/:name/users"  component={PracticeAdminUsers}></Route>
			<Route path="/practice_admin/:name/patients"  component={PracticeAdminPatients}></Route>
			<Route path="/practice_admin/:name/patients/:patientId"  component={PracticeAdminPatient}></Route>
			<Route path="/practice_admin/:name/getting_started" component={RegisterSuccess} />
			<Route path="/practice_admin/:name/patients/:patientId/history"  component={PatientViewDashboard}></Route>
		</Route>
		<Route path="/admin" adminRoute={true} component={App}>
			<IndexRoute force={true} component={Home}></IndexRoute>
			<Route  path="/admin/users" component={AdminUsers}></Route>
			<Route path="/admin/therapy_areas" component={AdminTherapyAreas}></Route>
			<Route path="/admin/therapy_categories" component={AdminTherapyCategories}></Route>
			<Route path="/admin/healtcare_professions" component={AdminPracticeTypes}></Route>
			<Route path="/admin/videos" component={AdminVideos}></Route>
			<Route path="/admin/user/:id" component={AdminUserProfile}></Route>
			<Route path="/admin/practices" component={AdminPractices}></Route>
			<Route path="/admin/practices/:id" component={AdminPractice}></Route>

		</Route>

		<Route path="/onboarding" publicRoute={true} component={App}>
			<IndexRoute component={Onboarding}></IndexRoute>
			<Route path="/onboarding/parent"  component={ParentOnboarding}></Route>
			<Route path="/onboarding/therapist"  component={TherapistOnboarding}></Route>
			<Route path="/onboarding/owner"  component={OwnerOnboarding}></Route>
		</Route>
		
	</Router>
</Provider>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js